<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="34"
    viewBox="0 0 40 34"
    fill="none"
  >
    <path
      d="M16.501 9.958C17.0778 10.5349 17.4706 11.2699 17.6298 12.0701C17.7889 12.8702 17.7072 13.6996 17.3949 14.4533C17.0827 15.207 16.554 15.8512 15.8757 16.3045C15.1973 16.7577 14.3998 16.9996 13.584 16.9996C12.7682 16.9996 11.9707 16.7577 11.2923 16.3045C10.614 15.8512 10.0853 15.207 9.77303 14.4533C9.46081 13.6996 9.37909 12.8702 9.53821 12.0701C9.69733 11.2699 10.0901 10.5349 10.667 9.958C11.05 9.57491 11.5048 9.27101 12.0053 9.06368C12.5058 8.85635 13.0422 8.74963 13.584 8.74963C14.1257 8.74963 14.6622 8.85635 15.1627 9.06368C15.6632 9.27101 16.1179 9.57491 16.501 9.958"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M29.9 19.75H25.5M1.66699 28.917V5.15899C1.66699 4.16655 2.06124 3.21476 2.763 2.513C3.46476 1.81124 4.41655 1.41699 5.40899 1.41699H34.667C35.1486 1.41686 35.6255 1.51162 36.0704 1.69586C36.5154 1.8801 36.9197 2.1502 37.2602 2.49074C37.6008 2.83128 37.8709 3.23558 38.0551 3.68054C38.2394 4.1255 38.3341 4.6024 38.334 5.08399V28.917C38.3341 29.3986 38.2394 29.8755 38.0551 30.3204C37.8709 30.7654 37.6008 31.1697 37.2602 31.5102C36.9197 31.8508 36.5154 32.1209 36.0704 32.3051C35.6255 32.4894 35.1486 32.5841 34.667 32.584H5.33399C4.8524 32.5841 4.3755 32.4894 3.93054 32.3051C3.48558 32.1209 3.08128 31.8508 2.74074 31.5102C2.4002 31.1697 2.1301 30.7654 1.94586 30.3204C1.76162 29.8755 1.66686 29.3986 1.66699 28.917V28.917ZM25.5 12.417H32.833H25.5Z"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.175 25.251C19.8548 24.4463 19.3587 23.7233 18.723 23.135V23.135C17.6474 22.1378 16.2348 21.5838 14.768 21.584H12.4C10.9336 21.584 9.52138 22.138 8.44604 23.135V23.135C7.80822 23.7227 7.31004 24.4457 6.98804 25.251"
      :stroke="clr ? clr : '#56606B'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
